import React, { useEffect, useMemo, useState } from 'react';
import { useFormikContext } from 'formik';
import { ButtonUI, DialogUI, FormErrorUI, InputUI } from '../Interface';
import { Box } from '@mui/material';
import { TemplateDocumentLevel, TemplateType } from '../../config/template';
import TextTemplateMenu from './TextTemplateMenu';

const NoteDialog = (props) => {
  const [text, setText] = useState('');
  const [contextMenu, setContextMenu] = useState(null);
  const { open, onClose, noteDialogState, currentDocType } = props;
  const { setFieldValue, errors, values, validateField } = useFormikContext();

  const templates = useMemo(
    () =>
      (currentDocType?.template ?? []).filter(
        (template) =>
          template?.templateType === TemplateType.TEXT && template?.documentLevel === TemplateDocumentLevel.LINE
      ),
    [currentDocType]
  );

  const fieldName = `docLine.${noteDialogState.valueIndex}.bpNote`;

  useEffect(() => {
    if (open) {
      setText(values?.docLine?.[noteDialogState.valueIndex]?.bpNote ?? '');
    } else {
      setContextMenu(null);
    }
  }, [open, values, noteDialogState.valueIndex]);

  const handleSave = async () => {
    await setFieldValue(fieldName, text);
    await validateField(fieldName);
    onClose();
  };

  return (
    <DialogUI open={open} onClose={onClose} headerContent="ÜP megjegyzés" maxWidth="lg" fullWidth>
      <Box mt="2rem">
        <InputUI
          value={text}
          type="text"
          variant="standard"
          fullWidth
          helperText={<FormErrorUI message={errors?.docLine?.[noteDialogState.valueIndex]?.bpNote} />}
          onChange={(e) => setText(e.target.value ?? '')}
          onContextMenu={(event) => {
            event.preventDefault();
            setContextMenu({ mouseX: event.clientX + 2, mouseY: event.clientY - 6 });
          }}
          multiline
          rows={12}
        />
      </Box>

      <TextTemplateMenu
        contextMenu={contextMenu}
        templates={templates}
        onClose={() => setContextMenu(null)}
        onSelect={(template) => {
          setText(template.body ?? '');
          setContextMenu(null);
        }}
      />

      <Box display="flex" justifyContent="center" gap="0.5rem" mt={2}>
        <ButtonUI text="Mentés" className="bg-success" onClick={handleSave} />
        <ButtonUI text="Mégsem" className="bg-primary" onClick={onClose} />
      </Box>
    </DialogUI>
  );
};

export default NoteDialog;
